import { Chart } from "chart.js/auto";
import React, { useEffect, useRef } from "react";

const Dashboard = () => {
  const trendRef = useRef(null);
  const funnelRef = useRef(null);
  const complianceRef = useRef(null);

  useEffect(() => {
    const commonGridColor = "#e5edf6";
    const commonTickColor = "#64748b";

    const trendChart = new Chart(trendRef.current, {
      type: "line",
      data: {
        labels: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
        datasets: [
          {
            label: "Voucher Redemptions",
            data: [4200, 5200, 6100, 7200, 6800, 7500, 8200],
            borderColor: "#1e90ff",
            backgroundColor: "rgba(30,144,255,.12)",
            fill: true,
            tension: 0.4,
            borderWidth: 3,
            pointRadius: 3,
          },
          {
            label: "Chatbot Engagement",
            data: [2800, 3400, 4100, 4700, 4550, 5120, 5900],
            borderColor: "#8b5cf6",
            backgroundColor: "rgba(139,92,246,.08)",
            fill: false,
            tension: 0.35,
            borderWidth: 3,
            pointRadius: 3,
          },
        ],
      },
      options: {
        maintainAspectRatio: false,
        plugins: {
          legend: { position: "top", labels: { usePointStyle: true } },
        },
        scales: {
          x: { grid: { color: commonGridColor }, ticks: { color: commonTickColor } },
          y: { grid: { color: commonGridColor }, ticks: { color: commonTickColor } },
        },
      },
    });

    const funnelChart = new Chart(funnelRef.current, {
      type: "bar",
      data: {
        labels: ["Reached", "Engaged", "Claimed", "Redeemed"],
        datasets: [
          {
            data: [120000, 82000, 64000, 42193],
            backgroundColor: ["#93c5fd", "#60a5fa", "#2563eb", "#1d4ed8"],
            borderRadius: 10,
          },
        ],
      },
      options: {
        maintainAspectRatio: false,
        plugins: { legend: { display: false } },
        scales: {
          x: { grid: { display: false }, ticks: { color: commonTickColor } },
          y: { grid: { color: commonGridColor }, ticks: { color: commonTickColor } },
        },
      },
    });

    const complianceChart = new Chart(complianceRef.current, {
      type: "bar",
      data: {
        labels: ["Jakarta", "Bandung", "Surabaya", "Medan", "Makassar", "Semarang"],
        datasets: [
          {
            label: "Compliance %",
            data: [92, 89, 85, 67, 78, 81],
            backgroundColor: ["#22c55e", "#22c55e", "#22c55e", "#f59e0b", "#16c7ff", "#8b5cf6"],
            borderRadius: 10,
          },
        ],
      },
      options: {
        maintainAspectRatio: false,
        plugins: { legend: { display: false } },
        scales: {
          x: { grid: { display: false }, ticks: { color: commonTickColor } },
          y: {
            beginAtZero: true,
            max: 100,
            grid: { color: commonGridColor },
            ticks: { color: commonTickColor },
          },
        },
      },
    });

    return () => {
      trendChart.destroy();
      funnelChart.destroy();
      complianceChart.destroy();
    };
  }, []);
  return (
    <div className="page active" id="page-dashboard">
      <div className="hero-dashboard">
        <div className="hero-copy-dash">
          <div className="eyebrow-dash">Portal Kartini</div>
          <h2>From Shelf to Screen</h2>
          <p>
            Deploying smarter consumer and trade promotions through one connected ecosystem for
            brands, retailers, field teams, and shoppers.
          </p>
          <div className="hero-actions-dash">
            <button className="btn-dash btn-dash-primary" type="button">
              Open Dashboard
            </button>
            <button className="btn-dash btn-dash-secondary" type="button">
              Explore Modules
            </button>
          </div>
        </div>

        <div className="hero-visual-dash">
          <div className="mini-dashboard">
            <div className="mini-head">
              <strong>Portal Overview</strong>
              <div className="mini-badge" aria-hidden="true"></div>
            </div>
            <div className="mini-grid">
              <div className="mini-card">
                <div className="t">Total Visits</div>
                <div className="v">11,665</div>
              </div>
              <div className="mini-card">
                <div className="t">Total Images</div>
                <div className="v">98,272</div>
              </div>
              <div className="mini-card">
                <div className="t">Projects</div>
                <div className="v">149</div>
              </div>
              <div className="mini-card">
                <div className="t">Active Rate</div>
                <div className="v">93%</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="stats-grid four">
        <div className="stat-card">
          <div className="stat-top">
            <div className="stat-label">Total Visits</div>
            <div className="info-chip">?</div>
          </div>
          <div className="stat-value">11,665</div>
          <div className="stat-sub">+12% vs last week</div>
          <div className="plus-badge">+</div>
        </div>

        <div className="stat-card">
          <div className="stat-top">
            <div className="stat-label">Total Images</div>
            <div className="info-chip">?</div>
          </div>
          <div className="stat-value">98,272</div>
          <div className="stat-sub">Display IR (Image Recognition) processed submissions</div>
          <div className="plus-badge">+</div>
        </div>

        <div className="stat-card">
          <div className="stat-top">
            <div className="stat-label">Active Campaigns</div>
            <div className="info-chip">?</div>
          </div>
          <div className="stat-value">14</div>
          <div className="stat-sub">Across 7 active client groups</div>
          <div className="plus-badge">+</div>
        </div>

        <div className="stat-card">
          <div className="stat-top">
            <div className="stat-label">Voucher Redemptions</div>
            <div className="info-chip">?</div>
          </div>
          <div className="stat-value">42,193</div>
          <div className="stat-sub">78% completion rate from claimed vouchers</div>
          <div className="plus-badge">+</div>
        </div>
      </div>

      <div className="panel-dash">
        <div className="panel-dash-header">
          <h3 className="panel-dash-title">Campaign Engagement Trend</h3>
          <div className="panel-dash-actions">
            <button className="btn-dash btn-dash-secondary" type="button">
              Last 7 Days
            </button>
          </div>
        </div>
        <div className="widget-pad">
          <div className="widget-chart tall">
            <canvas ref={trendRef}></canvas>
          </div>
        </div>
      </div>

      <div className="dashboard-grid-2">
        <div className="panel-dash">
          <div className="panel-dash-header">
            <h3 className="panel-dash-title">Voucher Redemption Funnel</h3>
          </div>
          <div className="widget-pad">
            <div className="widget-chart">
              <canvas ref={funnelRef}></canvas>
            </div>
            <div className="funnel-list">
              <div className="funnel-row">
                <div>Reached</div>
                <div className="funnel-track">
                  <div className="funnel-bar" style={{ width: "100%" }}></div>
                </div>
                <strong>120,000</strong>
              </div>
              <div className="funnel-row">
                <div>Engaged</div>
                <div className="funnel-track">
                  <div className="funnel-bar" style={{ width: "68%" }}></div>
                </div>
                <strong>82,000</strong>
              </div>
              <div className="funnel-row">
                <div>Claimed</div>
                <div className="funnel-track">
                  <div className="funnel-bar" style={{ width: "53%" }}></div>
                </div>
                <strong>64,000</strong>
              </div>
              <div className="funnel-row">
                <div>Redeemed</div>
                <div className="funnel-track">
                  <div className="funnel-bar" style={{ width: "35%" }}></div>
                </div>
                <strong>42,193</strong>
              </div>
            </div>
          </div>
        </div>

        <div className="panel-dash">
          <div className="panel-dash-header">
            <h3 className="panel-dash-title">Store Compliance by City</h3>
          </div>
          <div className="widget-pad">
            <div className="widget-chart">
              <canvas ref={complianceRef}></canvas>
            </div>
          </div>
        </div>
      </div>

      <div className="two-col">
        <div className="panel-dash">
          <div className="panel-dash-header">
            <h3 className="panel-dash-title">Retail Coverage Map</h3>
          </div>
          <div className="map-card">
            <div className="indo-map">
              <div className="island sumatra"></div>
              <div className="island java"></div>
              <div className="island kalimantan"></div>
              <div className="island sulawesi"></div>
              <div className="island papua"></div>
              <div className="island bali"></div>
              <div className="island ntt"></div>

              <div className="map-point mdn" title="Medan"></div>
              <div className="map-point jkt" title="Jakarta"></div>
              <div className="map-point bdg" title="Bandung"></div>
              <div className="map-point sby" title="Surabaya"></div>
              <div className="map-point dps" title="Denpasar"></div>
              <div className="map-point mks" title="Makassar"></div>
              <div className="map-point mdo" title="Manado"></div>
            </div>
            <div className="map-legend">
              <span>
                <span className="legend-dot"></span>High outlet activity cluster
              </span>
              <span>
                <span className="legend-dot" style={{ background: "#16c7ff" }}></span>Growing
                campaign coverage
              </span>
            </div>
          </div>
        </div>

        <div className="panel-dash">
          <div className="panel-dash-header">
            <h3 className="panel-dash-title">Live Campaign Status</h3>
          </div>
          <div className="status-stack">
            <div className="status-card-mini">
              <div>
                <h4>ABBOTT DVD GWP 2026</h4>
                <p>12,402 redemptions · 91% service uptime</p>
              </div>
              <span className="status-pill active">Live</span>
            </div>
            <div className="status-card-mini">
              <div>
                <h4>MORINAGA LOYALTY PROGRAM 2026</h4>
                <p>6,111 claims · Strong MT performance</p>
              </div>
              <span className="status-pill active">Stable</span>
            </div>
            <div className="status-card-mini">
              <div>
                <h4>NEUROBION DVD PHARMACY 2026</h4>
                <p>Alert: Medan compliance below threshold</p>
              </div>
              <span className="status-pill warn">Watch</span>
            </div>
            <div className="status-card-mini">
              <div>
                <h4>KALBE DANA TACTICAL 2025</h4>
                <p>Project archived with historical data retained</p>
              </div>
              <span className="status-pill inactive">Closed</span>
            </div>
          </div>
        </div>
      </div>

      <div className="three-col">
        <div className="panel-dash">
          <div className="panel-dash-header">
            <h3 className="panel-dash-title">Display IR Hotspot Heatmap</h3>
          </div>
          <div className="heatmap-grid">
            <div className="heat-cell heat-low">
              Mon <span>12%</span>
            </div>
            <div className="heat-cell heat-mid">
              Tue <span>28%</span>
            </div>
            <div className="heat-cell heat-high">
              Wed <span>41%</span>
            </div>
            <div className="heat-cell heat-very-high">
              Thu <span>63%</span>
            </div>
            <div className="heat-cell heat-extreme">
              Fri <span>84%</span>
            </div>
            <div className="heat-cell heat-high">
              Sat <span>48%</span>
            </div>
            <div className="heat-cell heat-mid">
              Sun <span>31%</span>
            </div>

            <div className="heat-cell heat-low">
              JKT <span>22</span>
            </div>
            <div className="heat-cell heat-mid">
              BDG <span>36</span>
            </div>
            <div className="heat-cell heat-high">
              SBY <span>44</span>
            </div>
            <div className="heat-cell heat-very-high">
              MDN <span>59</span>
            </div>
            <div className="heat-cell heat-extreme">
              MKS <span>71</span>
            </div>
            <div className="heat-cell heat-mid">
              SMG <span>34</span>
            </div>
            <div className="heat-cell heat-high">
              DPS <span>46</span>
            </div>
          </div>
        </div>

        <div className="panel-dash">
          <div className="panel-dash-header">
            <h3 className="panel-dash-title">OOS Risk Prediction</h3>
          </div>
          <div className="risk-grid">
            <div className="risk-card">
              <div className="risk-label">MT Channel</div>
              <div className="risk-value">18%</div>
              <div className="subtle-note">Projected OOS risk next 7 days</div>
              <div className="progress">
                <span style={{ width: "18%" }}></span>
              </div>
            </div>
            <div className="risk-card">
              <div className="risk-label">GT Channel</div>
              <div className="risk-value">31%</div>
              <div className="subtle-note">Higher exposure in rural coverage</div>
              <div className="progress">
                <span style={{ width: "31%" }}></span>
              </div>
            </div>
            <div className="risk-card">
              <div className="risk-label">Pharmacy</div>
              <div className="risk-value">24%</div>
              <div className="subtle-note">Moderate replenishment gap</div>
              <div className="progress">
                <span style={{ width: "24%" }}></span>
              </div>
            </div>
          </div>
        </div>

        <div className="panel-dash">
          <div className="panel-dash-header">
            <h3 className="panel-dash-title">AI Insights</h3>
          </div>
          <div className="insight-list">
            <div className="insight-item">
              <strong>Share-of-Voice is strongest in modern trade.</strong>
              <p>
                Jakarta and Surabaya continue to deliver the highest visibility and best display
                compliance across key chains.
              </p>
            </div>
            <div className="insight-item">
              <strong>Potential compliance leakage in Medan.</strong>
              <p>
                Display execution is still active, but OOS signals suggest weak replenishment
                discipline at store level.
              </p>
            </div>
            <div className="insight-item">
              <strong>Redemption pacing accelerated on Friday.</strong>
              <p>
                Campaign engagement peaks after payday windows, indicating strong timing leverage
                for voucher pushes.
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="dashboard-grid-2">
        <div className="panel-dash">
          <div className="panel-dash-header">
            <h3 className="panel-dash-title">Top Performing Cities</h3>
          </div>
          <div className="table-wrap">
            <table>
              <thead>
                <tr>
                  <th>City</th>
                  <th>Visits</th>
                  <th>Images</th>
                  <th>Compliance</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Jakarta</td>
                  <td>2,341</td>
                  <td>8,230</td>
                  <td>
                    <span className="status-pill active">92%</span>
                  </td>
                </tr>
                <tr>
                  <td>Bandung</td>
                  <td>1,904</td>
                  <td>6,554</td>
                  <td>
                    <span className="status-pill active">89%</span>
                  </td>
                </tr>
                <tr>
                  <td>Surabaya</td>
                  <td>1,112</td>
                  <td>4,334</td>
                  <td>
                    <span className="status-pill active">85%</span>
                  </td>
                </tr>
                <tr>
                  <td>Medan</td>
                  <td>879</td>
                  <td>3,112</td>
                  <td>
                    <span className="status-pill warn">67%</span>
                  </td>
                </tr>
                <tr>
                  <td>Makassar</td>
                  <td>742</td>
                  <td>2,809</td>
                  <td>
                    <span className="status-pill active">81%</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div className="panel-dash">
          <div className="panel-dash-header">
            <h3 className="panel-dash-title">Recent Activities</h3>
          </div>
          <div className="activity-feed">
            <div className="activity-item">
              <div className="activity-dot green"></div>
              <div>
                <div className="activity-title">Display submission approved – Indomaret Cikini</div>
                <div className="activity-desc">
                  Verification team approved shelf execution with complete SKU visibility and clean
                  store metadata.
                </div>
              </div>
              <div className="activity-time">2m ago</div>
            </div>
            <div className="activity-item">
              <div className="activity-dot"></div>
              <div>
                <div className="activity-title">
                  Voucher redemption spike detected – Abbott PediaSure
                </div>
                <div className="activity-desc">
                  Daily redemption volume exceeded weekly average by 24% after new WhatsApp blast
                  deployment.
                </div>
              </div>
              <div className="activity-time">18m ago</div>
            </div>
            <div className="activity-item">
              <div className="activity-dot violet"></div>
              <div>
                <div className="activity-title">
                  New campaign created – Morinaga Loyalty Program
                </div>
                <div className="activity-desc">
                  Project setup completed with retailer segmentation and outlet onboarding rules
                  enabled.
                </div>
              </div>
              <div className="activity-time">1h ago</div>
            </div>
            <div className="activity-item">
              <div className="activity-dot amber"></div>
              <div>
                <div className="activity-title">City performance updated – Bandung region</div>
                <div className="activity-desc">
                  Regional manager uploaded latest execution pack and city performance dashboards
                  were refreshed.
                </div>
              </div>
              <div className="activity-time">3h ago</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
